import { BgRetina } from 'app/components/ui/BgRetina'
import { Button } from 'app/components/ui/Button'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { Title } from 'app/components/ui/Title'
import { ScrollToTop } from 'app/routing/ScrollToTop'
import React from 'react'
import styled from 'styled-components'

type Props = {
  onNextStep: () => void
}

export const SponsorRequestThanks = ({ onNextStep }: Props): JSX.Element => {
  return (
    <>
      <ScrollToTop />
      <BgRetina
        paddingTop={0}
        bgImage='https://res.cloudinary.com/estra/image/upload/v1629375626/estra20dev/sponsor/documents_upload/document_registration_thanks_bg.svg'
      >
        <ThanksContainer>
          <TextWrapper>
            <Title size={3} mb={1.5}>
              Hai completato la richiesta di sponsorizzazione ma non la hai
              ancora inviata
            </Title>
            <Text variant='s24' mb={3}>
              Trovi la richiesta (con tutte quelle che eventualmente ci hai già
              sottoposto) nella pagina principale della tua Area Personale, in
              bozza. Puoi ancora effettuare modifiche, oppure, se sei pronto,
              inviarla.
            </Text>
          </TextWrapper>

          <Button size='lg' onClick={() => onNextStep()}>
            CHIUDI E TORNA ALLA PAGINA PRINCIPALE
          </Button>
        </ThanksContainer>
      </BgRetina>
    </>
  )
}

const ThanksContainer = styled(Container)`
  text-align: center;
`

const TextWrapper = styled.div`
  max-width: 900px;

  margin-right: auto;
  margin-left: auto;
`
